import { render } from "./HomeQuestionSubpage.vue?vue&type=template&id=585afefa&scoped=true"
import script from "./HomeQuestionSubpage.vue?vue&type=script&lang=js"
export * from "./HomeQuestionSubpage.vue?vue&type=script&lang=js"

import "./HomeQuestionSubpage.vue?vue&type=style&index=0&id=585afefa&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-585afefa"]])

export default __exports__